import { FAQ_ADD_FAIL, FAQ_ADD_REQUEST, FAQ_ADD_SUCCESS, FAQ_CLEAR, FAQ_DELETE_FAIL, FAQ_DELETE_REQUEST, FAQ_DELETE_SUCCESS, FAQ_EDIT_FAIL, FAQ_EDIT_REQUEST, FAQ_EDIT_SUCCESS, FAQ_LIST_FAIL, FAQ_LIST_REQUEST, FAQ_LIST_SUCCESS, FAQ_UPDATE_FAIL, FAQ_UPDATE_REQUEST, FAQ_UPDATE_RESET, FAQ_UPDATE_SUCCESS } from "../Constants/FaqConstants";


export const faqAddReducers = (state = { faqInfo: {} }, action) => {
  switch (action.type) {
    case FAQ_ADD_REQUEST:
      return { loading: true };
    case FAQ_ADD_SUCCESS:
      return { loading: false, success: true, faq: action.payload };
    case FAQ_ADD_FAIL:
      return { loading: false, error: action.payload };
    case FAQ_CLEAR:
      return {};
    default:
      return state;
  }
};

  
  export const faqListReducers = (
    state = { faq: [], currentPage: 1, totalPages: 0, totalRecords: 0, recordSize: 4 },
    action
  ) => {
    switch (action.type) {
      case FAQ_LIST_REQUEST:
        return { ...state, loading: true };
      case FAQ_LIST_SUCCESS:
        return {
          loading: false,
          faq: action.payload.faqs,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          totalRecords: action.payload.totalRecords,
          recordSize: action.payload.recordSize,
        };
      case FAQ_LIST_FAIL:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
export const faqEditReducer = (
  state = { faq: {} },
  action
) => {
  switch (action.type) {
    case FAQ_EDIT_REQUEST:
      return { ...state, loading: true };
    case FAQ_EDIT_SUCCESS:
      return { loading: false, faq: action.payload };
    case FAQ_EDIT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const faqUpdateReducer = (state = { faq: {} }, action) => {
  switch (action.type) {
    case FAQ_UPDATE_REQUEST:
      return { ...state, loading: true };
    case FAQ_UPDATE_SUCCESS:
      return { loading: false, success: true, faq: action.payload };
    case FAQ_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case FAQ_UPDATE_RESET:
      return { faq: {} };
    default:
      return state;
  }
};
export const faqDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case FAQ_DELETE_REQUEST:
      return { loading: true };
    case FAQ_DELETE_SUCCESS:
      return { loading: false, success: true };
    case FAQ_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
